// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsLinks_SyncChargeInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /subaccounts/links/sync_charge/{charge_id}?link_id={id}
 *
 * The charge_id is a URL path parameter. The link_id is required in the query string
 * (needed to identify which subaccount/provider to use).
 */
import { registerContract } from './validate'

export interface SubaccountsLinks_SyncChargeInput {
link_id: number
}

registerContract('SubaccountsLinks_SyncChargeInput', {
  link_id: { type: 'number',  required: true },
})
